import { AppButton, AppTextField } from 'components';
import { memo, useContext, useEffect, useState } from 'react';
import { ReactSortable } from 'react-sortablejs';
import Editor from 'components/CKEditor/Editor';
import { getRandomUid } from 'utilities/uuid.service';
import * as AppPics from 'assets/images';
import { EditorPreviewContext } from 'context/EditorPreviewContext';
import useDebounce from 'hooks/useDebounce';

function MatchTheFollowing({ handleSave, data }) {
  const { PreviewBtn } = useContext(EditorPreviewContext);
  const [currentEdited, updateCurrentEditBlock] = useState({});

  const editorData = useDebounce(currentEdited, 100);

  useEffect(() => {
    if (editorData.id) {
      updateCurrentEditBlock(editorData);
      if (editorData.section === 'b') {
        handleSave({
          matchChoicesPartB: data?.matchChoicesPartB?.map((x) => {
            if (x.id === editorData.id) x.option = editorData.data;
            return x;
          }),
        });
      }
      if (editorData.section === 'a') {
        handleSave({
          matchChoicesPartA: data?.matchChoicesPartA?.map((x) => {
            if (x.id === editorData.id) x.option = editorData.data;
            return x;
          }),
        });
      }
    }
  }, [editorData]);

  return (
    <div className="tab__content-actBody">
      <div className="px-5">
        <div className="row mt-4">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="lessonWrap lessonWrap--border topalign __match_t_f_sub">
              <div className="w-100 p-3">
                <label htmlFor="questionToFill">Question</label>
                {data?.title && <PreviewBtn block={{ value: data.title }} />}
                <Editor
                  data={{
                    value: data?.title || '',
                    onChange: (editorData) => {
                      handleSave({ title: editorData });
                    },
                  }}
                  config={{
                    placeholder: 'Enter only the question here.',
                  }}
                />
              </div>

              <div className="col-12">
                <label htmlFor="questionToFill">Choices to be matched</label>
              </div>

              <ReactSortable
                list={data?.matchChoicesPartA}
                setList={(newState) =>
                  handleSave({
                    matchChoicesPartA: newState,
                  })
                }
                handle=".grabHandleID"
              >
                {data?.matchChoicesPartA?.map((choice, index) => {
                  return (
                    <div className="lessonWrap  topalign py-0 grabHandleID" key={choice.id}>
                      <div className="w-100 p-3">
                        <label htmlFor="">Choice #{index + 1}</label>
                        <AppButton
                          variantClass="lessonWrap__btn leftpos dublicate"
                          title="Clone"
                          onClick={() => {
                            handleSave({
                              matchChoicesPartA: data?.matchChoicesPartA?.concat({
                                id: getRandomUid(),
                                option: choice.option,
                              }),
                            });
                          }}
                        >
                          <img src={AppPics.StampSvg} alt="clone this option" />
                        </AppButton>
                        <AppButton
                          variantClass="lessonWrap__btn leftpos delete"
                          onClick={() => {
                            handleSave({
                              matchChoicesPartA: data?.matchChoicesPartA?.filter(
                                (x) => x.id !== choice.id
                              ),
                            });
                          }}
                        >
                          <img src={AppPics.DeleteSvg} alt="delete this option" />
                        </AppButton>
                        {choice.option && <PreviewBtn block={{ value: choice.option }} />}
                        <AppTextField
                          labelProps={{ label: ' ' }}
                          inputProps={{
                            placeholder: 'Please provide your matching choice here',
                            value: choice.option,
                            onChange: (event) => {
                              handleSave({
                                matchChoicesPartA: data?.matchChoicesPartA?.map((x) => {
                                  if (x.id === choice.id) x.option = event.target.value;
                                  return x;
                                }),
                              });
                            },
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </ReactSortable>

              <div className="col-12">
                <AppButton
                  variantClass="btn-plane p--tint m-l-btn"
                  onClick={() => {
                    handleSave({
                      matchChoicesPartA: data?.matchChoicesPartA?.concat({
                        id: getRandomUid(),
                        option: '',
                      }),
                    });
                  }}
                >
                  + Add Choice
                </AppButton>
              </div>

              <br />

              <div className="col-12">
                <label htmlFor="questionToFill">
                  Add texts that matches the above added choices (Note the order must be the same as
                  above).
                </label>
              </div>

              <ReactSortable
                list={data?.matchChoicesPartB}
                setList={(newState) =>
                  handleSave({
                    matchChoicesPartB: newState,
                  })
                }
                handle=".grabHandleID"
              >
                {data?.matchChoicesPartB.map((choice, index) => {
                  return (
                    <div className="lessonWrap  topalign py-0 grabHandleID" key={choice.id}>
                      <div className="w-100 p-3">
                        <label htmlFor="">Match #{index + 1}</label>
                        <AppButton
                          variantClass="lessonWrap__btn leftpos dublicate"
                          title="Clone"
                          onClick={() => {
                            handleSave({
                              matchChoicesPartB: data?.matchChoicesPartB?.concat({
                                id: getRandomUid(),
                                option: choice.option,
                              }),
                            });
                          }}
                        >
                          <img src={AppPics.StampSvg} alt="clone this option" />
                        </AppButton>
                        <AppButton
                          variantClass="lessonWrap__btn leftpos delete"
                          onClick={() => {
                            handleSave({
                              matchChoicesPartB: data?.matchChoicesPartB.filter(
                                (x) => x.id !== choice.id
                              ),
                            });
                          }}
                        >
                          <img src={AppPics.DeleteSvg} alt="delete this option" />
                        </AppButton>
                        {choice.option && <PreviewBtn block={{ value: choice.option }} />}
                        <AppTextField
                          labelProps={{ label: ' ' }}
                          inputProps={{
                            placeholder: 'Please provide your matching choice here',
                            value: choice.option,
                            onChange: (event) => {
                              handleSave({
                                matchChoicesPartB: data?.matchChoicesPartB?.map((x) => {
                                  if (x.id === choice.id) x.option = event.target.value;
                                  return x;
                                }),
                              });
                            },
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </ReactSortable>

              <div className="col-12">
                <AppButton
                  variantClass="btn-plane p--tint m-l-btn"
                  onClick={() => {
                    handleSave({
                      matchChoicesPartB: data?.matchChoicesPartB?.concat({
                        id: getRandomUid(),
                        option: '',
                      }),
                    });
                  }}
                >
                  + Add Match
                </AppButton>
              </div>

              <div className="w-100 p-3 mt-4">
                <label htmlFor="">Hint</label>
                {data?.hint && <PreviewBtn block={{ value: data?.hint || '' }} />}
                <Editor
                  data={{
                    value: data?.hint || '',
                    onChange: (data) => handleSave({ hint: data }),
                  }}
                />
              </div>

              <div className="w-100 p-3">
                <label htmlFor="">Explanation</label>
                {data?.explanation && <PreviewBtn block={{ value: data?.explanation || '' }} />}
                <Editor
                  data={{
                    value: data?.explanation || '',
                    onChange: (data) => handleSave({ explanation: data }),
                  }}
                />
              </div>
              <div className="w-100 p-3">
                <AppTextField
                  labelProps={{ label: 'Marks' }}
                  inputProps={{
                    placeholder: 'Please provide the maximum marks allocated',
                    value: data?.marks || '',
                    onChange: (event) => handleSave({ marks: event.target.value }),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(MatchTheFollowing);
